import * as React from "react";
import { Deck, NavigateDirection } from "./Deck";
import { CardUtil } from "./CardUtil";
import { AppUtil } from "./AppUtil";

export interface IZoomedCardProps {
    deck: Deck;
    horizontal: boolean;
}
export class ZoomedCardComponent extends React.Component<IZoomedCardProps, any> {
    private div: HTMLDivElement;

    componentDidMount(): void {
        this.div.focus();
    }

    render() {
        let zoomClass = "zoomed-card";
        let aspectRatio = AppUtil.cardAspectRatio;
        let maxWidth = 800;
        let maxHeight = maxWidth / aspectRatio;
        if (this.props.horizontal) {
            zoomClass += " horizontal";
            aspectRatio = 1 / aspectRatio;
            maxHeight = 800;
            maxWidth = aspectRatio * maxHeight;
        }
        const padding = 25;
        const aw = window.innerWidth - 2 * padding;
        const ah = window.innerHeight - 2 * padding;
        const aar = aw / ah;
        let height = ah;
        let width = aw;



        if (this.props)
            //height is limiting
            if (aar > aspectRatio) {
                width = height * aspectRatio;

            } else {
                height = width / aspectRatio;

            }
        if (width > maxWidth) {
            width = maxWidth;
            height = width / aspectRatio;
        }
        if (height > maxHeight) {
            height = maxHeight;
            width = height * aspectRatio;
        }
        const top = (ah - height) / 2 + padding;
        const left = (aw - width) / 2 + padding;
        const style = {
            width: width,
            height: height,
            top: top,
            left: left
        };
        const card = this.props.deck.topCard();

        const css = zoomClass + " " + CardUtil.getCardCss(card, card.faceUp);
        return (
            <div className="backdrop" onClick={() => this.props.deck.toggleZoom()} tabIndex={1} onKeyDown={(e) => this.onKeyDown(e)} ref={(ref) => this.div = ref}>
                <div className={css} style={style}>
                </div>
            </div>
        );
    }

    onKeyDown(e: React.KeyboardEvent<HTMLDivElement>) {
        let handled = false;
        switch (e.key) {
            case "Escape":
                handled = this.props.deck.toggleZoom();
                break;
            case "ArrowRight":
                handled = this.props.deck.navigate(NavigateDirection.Right);
                break;
            case "ArrowLeft":
                handled = this.props.deck.navigate(NavigateDirection.Left);
                break;
            case "ArrowUp":
                handled = this.props.deck.navigate(NavigateDirection.Up);
                break;
            case "ArrowDown":
                handled = this.props.deck.navigate(NavigateDirection.Down);
                break;
            case "Delete":
                handled = this.props.deck.navigate(NavigateDirection.Delete);
                break;
            case "Enter":
                handled = this.props.deck.navigate(NavigateDirection.Enter);
                break;

        }
        if (handled) {
            e.stopPropagation();
            e.preventDefault();
            return true;
        }
        return false;
    }
}
